import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import movieSlice from "./movieSlice";
import gptSlice from "./gptSlice";
import languageSlice from "./languageSlice";

const appStore=configureStore({
    reducer:{
        user:userSlice,
        movie:movieSlice,
        gpt:gptSlice,
        language:languageSlice
    }
})
export default appStore